export const CLI_VERSION = process.env.FIBER_PAY_CLI_VERSION ?? 'unknown';
export const CLI_COMMIT = process.env.FIBER_PAY_CLI_COMMIT ?? 'unknown';
